import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { Route as pathlessAuthenticatedRoute } from '../../route';

const FileExtractionPage = lazyRouteComponent(
  () => import('./FileExtractionPage'),
  'FileExtractionPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/tools/file-extraction',
  staticData: {
    app: {
      access: {},
    },
  },
  component: FileExtractionPage,
  loader: () => ({
    crumb: msg('File Extraction', { context: 'page breadcrumb' }),
  }),
});
